import {
  ActionContext,
  ActionResult,
  ActionSpec,
} from '@/core/ambient-intelligence/types/ambient-intelligence.types';

import { ActionHandler, ActionRegistry } from '../../registries/ActionRegistry';

/**
 * Guest Login Action Handler
 * Handles login and dismiss actions for guest login cards
 */
class GuestLoginActionHandler implements ActionHandler {
  canHandle(action: ActionSpec): boolean {
    // Handle actions for guest-login content type
    return action.type === 'login' || action.type === 'dismiss';
  }

  async execute(action: ActionSpec, context: ActionContext): Promise<ActionResult> {
    switch (action.type) {
      case 'login':
        // The login action will trigger the inspect view
        // The actual login flow happens in the inspect view
        return {
          success: true,
          data: {
            message: 'Opening login flow',
            shouldOpenInspectView: true,
          },
        };

      case 'dismiss':
        // Dismiss is handled by the card component itself
        // This is just for logging/analytics
        return {
          success: true,
          data: {
            message: 'Guest login card dismissed',
            dismissedAt: new Date().toISOString(),
          },
        };

      default:
        return {
          success: false,
          error: `Unknown action type: ${action.type}`,
        };
    }
  }

  validate(params: any): { valid: boolean; error?: string } {
    // No params needed for login or dismiss actions
    return { valid: true };
  }
}

// Register the handler for guest-login actions
const guestLoginHandler = new GuestLoginActionHandler();
ActionRegistry.register('login', guestLoginHandler);
ActionRegistry.register('dismiss', guestLoginHandler);

console.log('✅ Guest login actions registered');

export { guestLoginHandler };
